import { Plus } from "lucide-react";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";

interface ButtonWidgetProps {
  label?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export default function ButtonWidget({
  label = "Novo Registro",
  onClick,
  disabled,
}: ButtonWidgetProps) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled ?? !onClick}
      className={cn("w-full h-full min-h-[60px] text-base", "shadow-sm")}
      size="lg"
    >
      <Plus className="w-5 h-5 mr-2" />
      {label}
    </Button>
  );
}
